/**
 * Shared card primitive. Maps to the existing App.css .card classes.
 *
 * Props:
 *   status    — 'success' | 'danger' | 'warning' for left-border status indicator (optional)
 *   className — extra class(es) on the card element
 *
 * All other props pass through to the root <div>.
 */
export default function Card({ status, className = '', children, ...props }) {
  const classes = ['card', status ? `card--${status}` : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
}
